module.exports = "/images/vendor/flag-icon-css/flags/4x3/sy.svg?64f0d2d7a590e22c8d0c415ba7d729af";